module.exports = __webpack_public_path__ + "img/robert_jones.2e549080.png";